<template>
  <div class="cover-upload">
    <el-upload
      drag
      action=""
      class="select-cover-image"
      accept="image/jpeg, image/png, image/gif"
      :show-file-list="false"
      :before-upload="selectCoverImageUpload">
      <template v-if="coverImage">
        <div class="cover-image">
          <img :src="coverImage">
          <div class="icons">
            <div class="icon-item" title="删除" @click.stop="deleteCoverImage">
              <img src="../../static/images/post/delete-icon.svg">
            </div>
            <div class="icon-item" title="修改">
              <img src="../../static/images/post/edit-icon.svg">
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="title">
          <img src="../../static/images/post/plus-icon.svg">
          添加封面
        </div>
        <p class="tip">支持2M以内jpg、png、gif格式图片，建议尺寸356*200px</p>
      </template>
    </el-upload>
    <el-dialog
      custom-class="cover-image-dialog"
      :show-close="false"
      :visible.sync="coverImageDialogVisible"
      @closed="afterCloseCoverImageDialog">
      <div slot="title">
        <span class="title">帖子封面图</span>
        <i class="icon-close" @click="coverImageDialogVisible = false" />
      </div>
      <template v-if="cropperImage">
        <vue-cropper
          ref="cropper"
          mode="contain"
          :img="cropperImage"
          :canScale="false"
          :canMove="false"
          :centerBox="true"
          :autoCrop="true"
          :autoCropWidth="356"
          :autoCropHeight="200"
          :fixed="true"
          :fixedNumber="[178, 100]"
        ></vue-cropper>
      </template>
      <template v-else>
        <el-upload
          drag
          action=""
          class="upload-cover-image"
          accept="image/jpeg, image/png, image/gif"
          :show-file-list="false"
          :before-upload="selectCoverImageUpload">
          <div class="title">
            <img src="../../static/images/post/plus-icon.svg">
            <div>添加封面</div>
          </div>
          <p class="tip">支持2M以内jpg、png、gif格式图片，建议尺寸356*200px</p>
        </el-upload>
      </template>
      <div slot="footer">
        <el-button class="delete" :disabled="!cropperImage" @click="deleteCropperImage">删除</el-button>
        <el-button class="save" @click="saveCoverImage">保存封面</el-button>
      </div>
    </el-dialog>
    <div class="upload-loading" v-if="isUploadLoading" v-loading="isUploadLoading"></div>
  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper';
import {
  getOSSSign,
  getFileNameUUID,
  getOSSPost,
  uploadOSSFile,
} from '@/api/basic/aliyunoss';

export default {
  components: {
    VueCropper,
  },
  props: {
    coverImage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      coverImageDialogVisible: false,
      cropperImage: '',
      limit: {
        imgMaxSize: 2,
        imgMaxSizeMsg: '上传图片大小不能超过',
      },
      isUploadLoading: false,
    };
  },
  methods: {
    selectCoverImageUpload(file) {
      const imgMaxSize = this.limit.imgMaxSize || 2;
      const imgMaxSizeMsg = this.limit.imgMaxSizeMsg || '上传图片大小不能超过';
      const imageType = file.type ? file.type.toLowerCase() : '';
      const isLt15M = file.size ? file.size / 1024 / 1024 < imgMaxSize : false;

      if (!imageType) {
        const imageSuffixs = ['.gif', '.png', '.jpg', '.jpeg'];
        const index = file.name.lastIndexOf('.');
        const suffix = file.name.substring(index).toLowerCase();
        if (!imageSuffixs.includes(suffix)) {
          this.$message({
            message: '仅支持jpg、png、gif类型图片',
            type: 'error',
          });
          return false;
        }
      } else if (imageType !== 'image/jpeg' && imageType !== 'image/png' && imageType !== 'image/gif') {
        this.$message({
          message: '仅支持jpg、png、gif类型图片',
          type: 'error',
        });
        return false;
      }

      if (!isLt15M) {
        this.$message({
          message: `${imgMaxSizeMsg} ${imgMaxSize}MB`,
          type: 'error',
        });
        return false;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        this.cropperImage = e.target.result;
      };
      reader.readAsDataURL(file);
      this.coverImageDialogVisible = true;
      return false;
    },
    saveCoverImage() {
      if (!this.cropperImage) {
        this.$message({
          message: '请先选择封面图片',
          type: 'warning',
        });
        return;
      }
      this.$refs.cropper.getCropBlob((data) => {
        let suffix = '';
        const imageType = data.type ? data.type.toLowerCase() : '';
        if (imageType === 'image/jpeg') {
          suffix = '.jpg';
        } else if (imageType === 'image/png') {
          suffix = '.png';
        } else if (imageType === 'image/webp') {
          suffix = '.webp';
        }
        const filename = `cover-image${suffix}`;
        const file = new File([data], filename, { type: data.type });
        file.key = getOSSPost() + getFileNameUUID() + suffix;
        this.uploadCoverImage(file);
        this.coverImageDialogVisible = false;
      });
    },
    uploadCoverImage(file) {
      getOSSSign().then((response) => {
        const flash = '/';
        const ossFormData = new FormData();
        ossFormData.append('key', file.key);
        ossFormData.append('signature', response.data.data.signature);
        ossFormData.append('policy', response.data.data.policy);
        ossFormData.append('OSSAccessKeyId', response.data.data.accessKeyId);
        ossFormData.append('success_action_status', '200');
        ossFormData.append('file', file);
        const ossAction = response.data.data.host;
        let cdnHost = response.data.data.cdnHost
        this.isUploadLoading = true;
        uploadOSSFile(ossAction, ossFormData).then((resp) => {
          console.log('uploadFile - OK', resp);
          const url = `${cdnHost}/${file.key}`;
          this.$emit('update-cover-image', url);
        }).catch((err) => {
          console.log(err);
          this.$message({
            showClose: true,
            message: '文件上传失败',
            type: 'error',
          });
        }).finally(() => {
          this.isUploadLoading = false;
        });
      }).catch((error) => {
        console.log(error);
        this.$message({
          showClose: true,
          message: '文件上传失败',
          type: 'error',
        });
      });
    },
    deleteCoverImage() {
      this.$emit('update-cover-image', '');
    },
    deleteCropperImage() {
      this.cropperImage = '';
    },
    afterCloseCoverImageDialog() {
      this.cropperImage = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.cover-upload {
  .select-cover-image {
    display: flex;
    /deep/ .el-upload {
      .el-upload-dragger:hover {
        transform: scale(1.05);
        box-shadow: 0px 10px 30px 0px rgba(0, 23, 43, 0.1);
      }
      .el-upload-dragger {
        box-sizing: content-box;
        width: 178px;
        height: 100px;
        background: #E9E9E9;
        border: 1px solid #E9EFF4;
        border-radius: 8px;
        font-size: 14px;
        color: #999999;
        transition: transform 0.15s ease-in-out;
        .cover-image {
          display: flex;
          position: relative;
          width: 100%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .icons {
            position: absolute;
            right: 7px;
            top: 7px;
            display: flex;
            .icon-item:first-child {
              margin-right: 6px;
            }
            .icon-item:hover {
              transform: translateY(-2px);
            }
            .icon-item {
              transition: transform 0.1s ease-in-out;
              opacity: 0.7;
              background: #000000;
              border-radius: 50px;
              width: 24px;
              height: 24px;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .title {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 22px;
          img {
            margin-right: 5px;
            width: 16px;
            height: 16px;
          }
        }
        .tip {
          font-size: 12px;
          margin: 5px 10px 0;
        }
      }
    }
  }
  /deep/ .el-dialog.cover-image-dialog {
    border-radius: 8px;
    width: 576px;
    .el-dialog__header {
      text-align: left;
      padding: 14px 33px;
      border-bottom: 1px solid #EAEAEA;
      .title {
        font-size: 16px;
        font-weight: 500;
        color: #333333;
      }
      .icon-close {
        background-image: url(../../static/images/editor/close.png);
        width: 32px;
        height: 32px;
        position: absolute;
        top: -45px;
        right: -15px;
        cursor: pointer;
      }
    }
    .el-dialog__body {
      margin-top: 22px;
      .vue-cropper {
        width: 356px;
        height: 200px;
        margin: 0 auto;
      }
      .upload-cover-image {
        display: flex;
        justify-content: center;
        .el-upload-dragger {
          width: 356px;
          height: 200px;
          border: none;
          border-radius: 0;
          background: #E9E9E9;
          font-size: 14px;
          color: #999999;
          .title {
            margin-top: 70px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img {
              margin-bottom: 5px;
            }
          }
          .tip {
            margin: 10px 50px 0;
            line-height: 20px;
            font-size: 12px;
            text-align: left;
          }
        }
      }
    }
    .el-dialog__footer {
      text-align: center;
      padding: 55px 31px 35px;
      .el-button {
        width: 110px;
        height: 40px;
        margin: 0;
        background: #005FB4;
        color: #fff;
        font-size: 14px;
        border: none;
        border-radius: 4px;
      }
      .delete {
        margin-right: 16px;
        background: #FBFBFB;
        color: #666666;
        border: 1px solid #CBCBCB;
      }
    }
  }
  .upload-loading {
    position: fixed !important;
    top: 0;
    left: 0;
    z-index: 2999;
    width: 100vw;
    min-height: 100vh;
  }
}
</style>
